import { type ReactNode } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type Props = {
  children?: ReactNode;
  className?: string;
};

export const NotificationCenterFooter = ({ children, className }: Props) => (
  <div
    className={cnTwMerge(
      "px-4 py-3 border-t-1 border-border/primary",
      className,
    )}
    data-testid="notification-center-footer"
  >
    {children}
  </div>
);
